let last_time = 0, use_prefix = 'LOG'

//https://stackoverflow.com/questions/9781218/how-to-change-node-jss-console-font-color
/**
 * some default colors to pick from so to not memorize the format
 */
export const console_colors = {
    Reset: "\x1b[0m",
    Bright: "\x1b[1m",
    Dim: "\x1b[2m",
    Underscore: "\x1b[4m",
    Blink: "\x1b[5m",
    Reverse: "\x1b[7m",
    Hidden: "\x1b[8m",

    FgBlack: "\x1b[30m",
    FgRed: "\x1b[31m",
    FgGreen: "\x1b[32m",
    FgYellow: "\x1b[33m",
    FgBlue: "\x1b[34m",
    FgMagenta: "\x1b[35m",
    FgCyan: "\x1b[36m",
    FgWhite: "\x1b[37m",

    BgBlack: "\x1b[40m",
    BgRed: "\x1b[41m",
    BgGreen: "\x1b[42m",
    BgYellow: "\x1b[43m",
    BgBlue: "\x1b[44m",
    BgMagenta: "\x1b[45m",
    BgCyan: "\x1b[46m",
    BgWhite: "\x1b[47m"
}

/**
 * short form of log, since i type it so much and the default is too long
 * @param {object[]} objs infinite other parameters to the function that will be console logged
 */
export function log(...objs) { console.log(...objs) }

/**
 * prints console traces of all of the given function parameters
 * @param {Array} objs infinite other parameters to the function that will be console logged
 */
export function log_call_stack(...objs) { console.trace(...objs) }

/**
 * Logs an error and the errored object if there is one and exits the process
 * @param {string} msg
 * @param {Array} objs infinite other parameters to the function that will be console logged
 */
export function error(msg, ...objs) {
    console.log(`${prefix(`${use_prefix} ERROR`, console_colors.BgRed + console_colors.FgWhite)} 😐 Bruh...\n\n${msg}`)
    if (objs)
        console.log(...objs, '\n')

    throw new Error(msg)
}

/**
 * Logs an error and the errored object if there is one but continues without exiting
 * @param {string} msg 
 * @param {Array} objs infinite other parameters to the function that will be console logged
 */
export function soft_error(msg, ...objs) {
    console.log(`${prefix(`${use_prefix} ERROR`, console_colors.BgRed + console_colors.FgWhite)} ${msg}`)
    if (objs)
        console.log(...objs, '\n')
}

/**
 * @param {string} msg 
 * @param {object} obj prints out a console trace of this object
 * @param {boolean} exit should the process exit after this log?
 */
export function TODO(msg = '', obj = null, exit = false) {
    console.log(`${prefix(`${use_prefix} TODO`, console_colors.FgYellow)} Not implemented:`, msg, '\n')
    if (obj) console.trace(obj)
    if (exit) process.exit(1)
    return null
}

/**
 * console logs a greem bg prefixed string with a formatted time since last stopwatch trigger
 * @param {string} msg
 */
export function done(msg) {
    console.log(`${prefix(`${use_prefix}`, console_colors.BgGreen)} ${msg} - ${fTime(endTimer())}`)
}

/**
 * console logs a yellow bg prefixed string with a formatted time since last stopwatch trigger
 * @param {string} msg
 * @param {string} color
 */
export function info(msg, color = console_colors.BgYellow) {
    console.log(`${prefix(use_prefix, color)} ${msg} - ${fTime(endTimer())}`)
}

export function startTimer() {
    last_time = performance.now()
}

/**
 * @param {boolean} reset
 */
export function endTimer(reset = false) {
    let ms = performance.now() - last_time
    if (reset) startTimer()
    return ms.toFixed(2)
}

/**
 * returns a colored prefix string and resets the console colors right after it
 * @param {string} msg
 * @param {string} colors
 */
export function prefix(msg = use_prefix, colors = '') {
    return `${colors}[${msg}]${console_colors.Reset}`
}

/**
 * returns unit formatted time string from ms to sec, min, h as needed
 * @param {string} msg
 * @param {string} colors
 */
export function fTime(ms) {
    switch (true) {
        case ms > 1000 * 60 * 60: return (ms / (1000 * 60 * 60)).toFixed(2) + 'h';
        case ms > 1000 * 60: return (ms / (1000 * 60)).toFixed(2) + 'm';
        case ms > 1000: return (ms / 1000).toFixed(2) + 's';
        default: return ms + 'ms';
    }
}

export function setPrefix(pre = '') {
    use_prefix = pre
}